import React from "react";
import Comment from "./components/Comment";

const App = () => {
  return (
    <>
      <Comment />
    </>
  );
};
export default App;
